import { useMediaQuery } from "../Hooks/useMediaQuery";

const DASH = 10;
const DASH_GAP = 6;

export const MovingOutline = () => {
  const reduceMotion = useMediaQuery("(prefers-reduced-motion: reduce)");

  return (
    <svg data-testid="card-edit-outline" aria-hidden className="absolute inset-0 z-10 w-full h-full pointer-events-none">
      <rect
        width="100%"
        height="100%"
        rx={8}
        fill="none"
        strokeWidth={4}
        strokeDasharray={`${DASH} ${DASH_GAP}`}
        className="stroke-theme-focus"
      >
        {!reduceMotion && (
          <animate attributeName="stroke-dashoffset" values={`0;${-(DASH + DASH_GAP)}`} dur="0.8s" repeatCount="indefinite" />
        )}
      </rect>
    </svg>
  );
};
